<script setup lang="ts">
import { useTutorApplicationStore } from '../model/store'
import FormBox from './FormBox.vue'
import InputFullName from './personal-information/InputFullName.vue'
import InputEmail from './personal-information/InputEmail.vue'
import InputPhone from './personal-information/InputPhone.vue'

defineOptions({
  name: 'PersonalInformation',
})

const tutorApplicationStore = useTutorApplicationStore()

const setClear = (): void => {
  tutorApplicationStore.resetPersonalInformation()
}

</script>

<template>
  <FormBox
    title="Personal information"
    @click:clear="setClear"
  >
    <div class="personal-information__fields">
      <div class="personal-information__fields-info">
        <InputFullName />
        <InputEmail />
      </div>
      <InputPhone />
    </div>
  </FormBox>
</template>

<style scoped lang="scss" src="./PersonalInformation.scss" />
